import initData from "@/utils/initData";
import uuid from 'uuid/dist/v1';
export default {
    get_uuid: function(){
        return uuid().toString().replaceAll("-","")
    },
    /**
     * 个位数补零
     * @param number
     * @returns {string|string}
     */
    addZero: function(number) {
        return number < 10 ? "0" + number : number.toString()
    },
    /**
     * 校验传入的日期是班/休
     * @param dateStr 校验日期 例"2022-01-01"
     * @returns {number} 0 正常工作日、 1：调休日、 2：调班日
     */
    checkWork: function(dateStr) {
        let e = 0;
        if (initData.restDays.search(dateStr) >= 0){
            e = 2;
        }else if(initData.workDays.search(dateStr) >= 0){
            e = 1;
        }
        return e
    },
    /**
     * 获取两个日期相差的天数
     * @param startDate 开始日期
     * @param endDate 结束日期
     * @returns {number} 相差天数
     */
    getIntervalDays: function(startDate, endDate) {
        startDate = parseInt(new Date(startDate).getTime() / 1000);
        endDate = parseInt(new Date(endDate).getTime() / 1000);
        return parseInt((startDate - endDate) / (3600*24));
    },
    /**
     * 获取目标月的每一天
     * @param currentSolarMonth 目标阳历月对象
     * @returns {*|[]}
     */
    getMonthDays: function(currentSolarMonth={}) {

        let days = currentSolarMonth.getDays();

        const monthFirstDay = days[0];
        const monthLastDay = days[days.length -1];

        let monthFirstWeek = monthFirstDay.getWeek() - 1;
        if(monthFirstWeek === -1){
            monthFirstWeek = 6;
        }
        for (let i=0; i<monthFirstWeek; i++){
            days.unshift(monthFirstDay.next(-(i+1)));
        }
        let monthLastWeek = 7 - monthLastDay.getWeek();

        if(monthLastWeek === 7){
            monthLastWeek = 0
        }
        for (let i=0; i < monthLastWeek; i++){
            days.push(monthLastDay.next(i+1));
        }
        return days
    },
    /**
     * 获取节日名字
     */
    getViceDay: function(dayItem){
        const holidayItem = initData.view.holidayItem;
        const holidayStr = initData.view.holidayStr;

        const lunarItem = dayItem.getLunar();
        const jieQi = lunarItem.getJieQi();

        const solarMonth = dayItem.getMonth();
        const monthDay = dayItem.getMonth().toString().padStart(2,0) + dayItem.getDay().toString().padStart(2,0);
        let viceDay = dayItem.getLunar().getDayInChinese();
        let viceColor = false;
        // 公历节日
        if(monthDay in holidayItem){
            viceDay = holidayItem[monthDay];
            viceColor = true;
        }else if(solarMonth === 5){
            const weekIndex = SolarWeek.fromYmd(dayItem.getYear(), 5, dayItem.getDay(), 1).getIndex();
            if (weekIndex === 2 && dayItem.getWeek() === 0){
                viceDay = "母亲节";
                viceColor = true;
            }

        }else if(solarMonth === 6){
            const weekIndex = SolarWeek.fromYmd(dayItem.getYear(), 5, dayItem.getDay(), 1).getIndex();
            if (weekIndex === 3 && dayItem.getWeek() === 0){
                viceDay = "父亲节";
                viceColor = true;
            }
        }
        // 节气
        if(jieQi !== ""){
            viceDay = jieQi;
            viceColor = true;
        }
        // 农历节日
        const festivals = lunarItem.getFestivals();
        festivals.forEach((item)=>{
            if (holidayStr.search(item) >= 0){
                viceDay = item;
                viceColor = true;
            }
        })
        // 南方小年 北方小年
        if (lunarItem.getMonth() === 12){
            const lunarDay = lunarItem.getDay();
            if (lunarDay === 23){
                // 北方小年
                viceDay = "北小年";
                viceColor = true;
            }else if(lunarDay === 24){
                viceDay = "南小年";
                viceColor = true;
            }
        }
        return {
            viceDay: viceDay,
            viceColor: viceColor,
        }
    },
    splitRepeatInfo: function(repeatInfo, infoType){
        repeatInfo = parseInt(repeatInfo);

        if(infoType === "date"){
            // 拆分 月日
            return {month: Math.floor(repeatInfo / 100), day: repeatInfo % 100}
        }else{
            // 拆分 月周
            return {weekIndex: Math.floor(repeatInfo / 10), week: repeatInfo % 10}
        }
    },
    minuteToTime: function(startTime){
        return {
            hour: this.addZero(Math.floor(startTime/60)),
            minute: this.addZero(startTime%60)
        }
    },

    getDateStr: function(ymd){
        const todayDate = new Date();
        const date = new Date(ymd);

        let text = date.getMonth() + 1 + "月" + date.getDate() + "日";

        if(todayDate.getFullYear() !== date.getFullYear()){
            // 显示年份
            text = date.getFullYear() + "年" + text;
        }
        return text;
    },
    getHourItems: function(upFoldIndex, downFoldIndex){
        const hourItems = [];
        for (let i=0; i<24; i++){
            let foldAllow=false;

            if (upFoldIndex > -1 && i <= upFoldIndex){
                continue
            }else if(downFoldIndex < 24 && i >= downFoldIndex){
                continue
            }else if ((upFoldIndex === -1 && i< 10) || (downFoldIndex === 24 && i>13)){
                foldAllow = true;
            }
            hourItems.push({
                index: i,
                hour: this.addZero(i),
                foldAllow: foldAllow,
            })
        }
        return hourItems
    },
}